export function parseCustomFilter(
  filter: string | undefined,
  feedbackName: string
): string | null {
  if (!filter) {
    return null;
  }
  const filterWithoutSpaces = filter.replace(/\s/g, '');
  const operator = filterWithoutSpaces[0];
  const firstTwo = filterWithoutSpaces.slice(0, 2);
  const scoreInput = filterWithoutSpaces.slice(
    filterWithoutSpaces[1] === '=' ? 2 : 1
  );
  const scoreNumber = Number(scoreInput);
  if (!scoreInput || isNaN(scoreNumber)) {
    return null;
  }
  let filterOperator: string | null = null;
  if (firstTwo === '>=') {
    filterOperator = 'gte';
  } else if (firstTwo === '<=') {
    filterOperator = 'lte';
  } else if (operator === '<') {
    filterOperator = 'lt';
  } else if (operator === '>') {
    filterOperator = 'gt';
  } else if (operator === '=') {
    filterOperator = 'eq';
  }
  return (
    operator &&
    `and(eq(feedback_key, "${feedbackName}"), ${filterOperator}(feedback_score, ${scoreNumber}))`
  );
}
